import { getParamsFromQueryString } from '../../utils/url'
import { all, call, takeLatest, put, select } from 'redux-saga/effects'

import { showGenericMessage } from '../app/actions'
import * as actions from './actions'
import * as types from './constants'
import * as services from './services'
import qs from 'query-string'

const { app_id: appId, url_redirect: urlRedirect } = getParamsFromQueryString()
const olysAppIds = ['23', '26', '28', '29', '31', '32', '33', '36', '37', '47']

export function * signIn ({ payload }) {
  const { data, translation } = payload
  const response = yield call(services.signIn, data)
  if (response.status === 200) {
    yield put(actions.signInSuccessful(response.data))
  } else if (response.status === 303) {
    yield put(actions.signInTemporarySuccess(response.data))
    const appUrl = qs.parseUrl(urlRedirect)
    window.location.href = `/change_temporary_password?app_id=${appId}&url_redirect=${appUrl.url}?${qs.stringify({ ...appUrl.query, token: response.data.user.token }, { encode: false })}`
  } else if (response.status === 401) {
    yield put(showGenericMessage(response.data.error))
    yield put(actions.signInFailure(response.data.error))
  } else if (response.status === 204) {
    yield put(showGenericMessage(translation('login')['loginError']))
    yield put(actions.signInFailure(response.data.error))
  }
}

export function * signUp ({ payload }) {
  const { data, translation } = payload

  try {
    const { lang } = yield select(state => state.auth)
    const userData = yield call(services.signUp, { ...data, provider: 'SSO', locale: lang })
    if (olysAppIds.includes(appId)) {
      yield put(actions.signUpSuccessful(userData))
    } else {
      yield put(actions.signUpSuccessful(userData))
      yield put(actions.signInSuccessful(userData))
    }
  } catch (error) {
    const errorData = error.response.data
    yield put(actions.signUpFailure(error.response.data))

    if (errorData.email) {
      yield put(showGenericMessage(translation('register')['emailInUse']))
    } else {
      yield put(showGenericMessage(translation('register')['registerError']))
    }
  }
}

export function * updateEmail ({ payload }) {
  try {
    const userData = yield call(services.updateEmail, payload)
    yield put(actions.updateEmailSuccessful(userData))
  } catch (error) {
    const errorData = error.response.data
    yield put(actions.updateEmailFailure(error.response.data))

    if (errorData.email) {
      yield put(showGenericMessage(`Email: ${errorData.email}`))
    } else {
      yield put(showGenericMessage(`Não foi possível realizar o cadastro.`))
    }
  }
}

export function * getMyData ({ payload: token }) {
  try {
    const userData = yield call(services.getMyData)
    yield put(actions.getMyDataSuccessful({
      ...userData,
      token
    }))
  } catch (error) {
    yield put(actions.getMyDataFailure(error))
  }
}

export function * logout () {
  yield call(services.logout)
}

// Watchers
export function * watchSignIn () {
  yield takeLatest(types.SIGN_IN, signIn)
}

export function * watchSignUp () {
  yield takeLatest(types.SIGN_UP, signUp)
}

export function * watchUpdateEmail () {
  yield takeLatest(types.UPDATE_EMAIL, updateEmail)
}

export function * watchLogout () {
  yield takeLatest(types.LOGOUT, logout)
}

export function * watchGetMyData () {
  yield takeLatest(types.GET_MY_DATA, getMyData)
}

export default function * authSagas () {
  yield all([
    watchSignIn(),
    watchSignUp(),
    watchUpdateEmail(),
    watchLogout(),
    watchGetMyData()
  ])
}
